// https://scrollscan.com/address/0x03073D3F4769f6b6604d616238fD6c636C99AD0A
export const CROSS_CHAIN_CONTROLLER = '0x03073D3F4769f6b6604d616238fD6c636C99AD0A';

// IPayloadsControllerCore https://scrollscan.com/address/0x6b6B41c0f8C223715f712BE83ceC3c37bbfDC3fE
export const PAYLOADS_CONTROLLER = '0x6b6B41c0f8C223715f712BE83ceC3c37bbfDC3fE';

// https://scrollscan.com/address/0xf438e33dCCEE260ee4371F9dceF408b0d7DBe424
export const PC_DATA_HELPER = '0xf438e33dCCEE260ee4371F9dceF408b0d7DBe424';

// https://scrollscan.com/address/0xa835707d28e6C37C49d661742f2Fb5987367cEd4
export const GRANULAR_GUARDIAN = '0xa835707d28e6C37C49d661742f2Fb5987367cEd4';

// https://scrollscan.com/address/0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b
export const GOVERNANCE_GUARDIAN = '0x1A0581dd5C7C3DA4Ba1CDa7e0BcA7286afc4973b';

// https://scrollscan.com/address/0xc1ABF87FfAdf4908f4eC8dc54A25DCFEabAE4A24
export const EXECUTOR_LVL_1 = '0xc1ABF87FfAdf4908f4eC8dc54A25DCFEabAE4A24';

export const CHAIN_ID = 534352;
